import { axiosOtherTrackerInstance } from "../../configs/AxiosInstance";

export const modifyTargetPlanSteps = async (post, payload) => {
  try {
    const response = await post(`/modify-target-plan-steps`, payload, {
      instance: axiosOtherTrackerInstance,
    });

    if (
      response &&
      (response.status === 200 || response.data || response.message)
    ) {
      return {
        success: true,
        message: response.message,
        data: {
          summary: response.summary || null,
          targetPlan: response.data?.target_plan || null,
          durations: response.data?.durations?.records || [],
          splits: response.data?.splits?.records || [],
        },
      };
    }

    return {
      success: false,
      message: "Failed to modify target plan steps",
    };
  } catch (error) {
    console.error("Error modifying target plan steps:", error);
    return {
      success: false,
      message: "Error modifying target plan steps",
    };
  }
};
